module.exports = __webpack_public_path__ + "img/9b_ESAIC.285a6ef7.jpg";